exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#ccDiv[data-v-13e4ccf3]{\n    padding: 8px;\n    border-radius: 5px;\n}\n.botMargin[data-v-13e4ccf3]{\n    margin-bottom: 60px;\n}\n", "", {"version":3,"sources":["/codebuild/output/src663559002/src/slink-frontend/src/pages/Pmt.vue"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;CACtB;AACD;IACI,oBAAoB;CACvB","file":"Pmt.vue","sourcesContent":["\n#ccDiv[data-v-13e4ccf3]{\n    padding: 8px;\n    border-radius: 5px;\n}\n.botMargin[data-v-13e4ccf3]{\n    margin-bottom: 60px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13e4ccf3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Pmt.vue
// module id = Rh1T
// module chunks = 1